export default __webpack_public_path__ + "static/media/icon-return-repaired-phone.f3fc1477.svg";